import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { takeUntil } from 'rxjs/operators';
import { AppComponent } from 'src/app/app.component';


@Component({
    selector: 'app-user-authorize',
    templateUrl: './user-authorize.component.html',
    styleUrls: ['./user-authorize.component.css']
})
export class UserAuthorizeComponent  implements OnInit {

    constructor(
        private appComponent: AppComponent,
        private router: Router) {}
    

    ngOnInit(): void {
        this.appComponent.triggerLoader('show');
     
    }
}
